import { Box, Center, Flex, Text } from '@chakra-ui/react'
import { ErrorMessage } from '@sequencehq/core-components'
import {
  GreyGrey0,
  GreyGrey80,
  Lato14ExtendedRegular,
  Lato20Bold
} from '@sequencehq/design-tokens'
import React, { FC } from 'react'

interface SettingsPageLayoutProps {
  header: string
  subheader?: string
  actions?: React.ReactNode
  backButton?: {
    href: string
    label: string
  }
  children: React.ReactNode
  isError?: boolean
}

export const SettingsPageLayout: FC<SettingsPageLayoutProps> = ({
  subheader,
  header,
  actions,
  children,
  isError
  // backButton
}) => {
  return (
    <Box
      backgroundColor={GreyGrey0}
      minHeight="100svh"
      width="100%"
      paddingY="40px"
    >
      <Flex flexDirection="column" width="600px" margin="auto" gap="32px">
        <Flex justifyContent="space-between">
          <Flex flexDirection="column" width="100%">
            <Text {...Lato20Bold} color={GreyGrey80}>
              {header}
            </Text>
            {subheader?.length && (
              <Text
                marginTop="8px"
                {...Lato14ExtendedRegular}
                color={GreyGrey80}
              >
                {subheader}
              </Text>
            )}
          </Flex>
          {actions}
        </Flex>

        {isError ? (
          <Center paddingY="10rem">
            <ErrorMessage />
          </Center>
        ) : (
          children
        )}
      </Flex>
    </Box>
  )
}
